import { Link } from "react-router-dom";
import { getDocUrl } from "./docUrl";

const CrfDocLink = ({ crfExtension, externalUrl, crfName, crfId }) => {
  const fileName = externalUrl.split("/").pop();
  const ahref = getDocUrl(externalUrl);

  return (
    <>
      {" "}
      {crfExtension !== ".noc" ? (
        <a href={ahref} download={fileName} rel="noreferrer">
          {crfName}
        </a>
      ) : (
        <Link to={`/curesickle/noc-report/${crfId}/${crfName}`}>{crfName}</Link>
      )}
    </>
  );
};

export default CrfDocLink;
